<template>
  <div class="pr-4 pl-3 py-3 space-y-3 cursor-pointer">
    <CtaTeacher v-if="auth.user.role === 'teacher'" />
    <template v-for="(item,i) in avatarList">
      <component
        :is="item.component"
        :key="i"
        :tag-link="item.tagLink"
        :text="item.text"
        :icon="item.icon"
      />
    </template>
  </div>
</template>

<script>
import CtaTeacher from '@library/element/dropdown/dropdown-list/cta-teacher.vue'
import AvatarUserWallet from './avatar-user-wallet'
import AvatarUserItem from './avatar-item'

export default {
  name: 'ListAvatar',
  components: { AvatarUserWallet, CtaTeacher, AvatarUserItem },
  inject: ['allProps'],
  computed: {
    auth () {
      return this.allProps.data.auth
    },
    avatarList () {
      return this.allProps.data.linksHeaderTop.avatarList
    }
  }

}
</script>
